import React, { useState } from 'react';
import CastColor from './CastColor';
import ChartOverlay from './ChartOverlay';

export default function CastSetting({ colors, setChartColors, densityWindow, setDensityWindow, maxDuration, onOpenCombo }: {
    colors: string[]; setChartColors: (colors: string[]) => void;
    densityWindow: number; setDensityWindow: (value: number) => void;
    maxDuration: number; onOpenCombo: () => void;
}) {
    const [settingsOpen, setSettingsOpen] = useState(false);
    return <>
        <div className="bg-white border-b shrink-0 flex items-center gap-1 md:gap-3 pl-14 pr-2 py-2">
            <CastColor colors={colors} updateColors={setChartColors} />
            <button type="button" aria-haspopup="dialog" onClick={() => setSettingsOpen(true)}
                title="Density window" className="shrink-0 rounded border px-2 py-2 text-sm text-gray-700 hover:bg-gray-50">
                {densityWindow}s
            </button>
            <button type="button" aria-haspopup="dialog" onClick={onOpenCombo}
                className="ml-auto shrink-0 whitespace-nowrap rounded bg-blue-600 px-2 py-2 text-sm font-semibold text-white hover:bg-blue-700">
                Best combo
            </button>
        </div>
        <ChartOverlay open={settingsOpen} title="Chart settings" onClose={() => setSettingsOpen(false)}>
            <div className="p-4 space-y-4">
                <div>
                    <label htmlFor="density-window" className="block text-sm font-semibold">Density Window: {densityWindow}s</label>
                    <input id="density-window" type="range" min="1" max={Math.max(10, Math.ceil(maxDuration))}
                        value={densityWindow} onChange={event => setDensityWindow(Number(event.target.value))}
                        className="w-full h-2 mt-4 mb-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500" />
                    <p className="text-xs text-gray-500">The density bar counts notes in the preceding {densityWindow} seconds.</p>
                </div>
            </div>
        </ChartOverlay>
    </>;
}
